import { createUseStyles } from 'react-jss'
import clsx from 'clsx'
import HTMLParser from 'react-html-parser'
import BlockTitle from '@/components/BlockTitle'
import style from './style'

const useStyles = createUseStyles(style)

function IntroText({ pretitle, title, theme }) {
  const classes = useStyles()

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.rootDark]: theme === 'dark',
      })}
    >
      <div className={classes.title}>
        <div className={classes.pretitle}>
          {HTMLParser(pretitle)}
        </div>
        <div>
          <BlockTitle data={{ title: HTMLParser(title) }} />
        </div>
      </div>
    </div>
  )
}

export default IntroText
